import { get, writable } from 'svelte/store';

import { userStore } from '@client/stores/user';

import { LocalStorage } from '@client/utils/local-storage';

const initialUserStore = get(userStore);

export let activitySettingsStore = writable({});
export let appSettingsStore = writable({});
export let auditSettingsStore = writable({});
export let bizStudioSettingsStore = writable({});
export let campaignsSettingsStore = writable({});
export let documentsSettingsStore = writable({});
export let domainSettingsStore = writable({});
export let domainsSettingsStore = writable({});
export let groupsSettingsStore = writable({});
export let imagesSettingsStore = writable({});
export let integrationsSettingsStore = writable({});
export let staffSettingsStore = writable({});
export let studioSettingsStore = writable({});
export let usersSettingsStore = writable({});
export let videosSettingsStore = writable({});
export let workflowsSettingsStore = writable({});

const updateStores = (store) => {
  const { domain } = store;

  if (!domain) {
    return store;
  }

  [
    'activity',
    'app',
    'audit',
    'bizcards-studio',
    'campaigns',
    'documents',
    'domain-settings',
    'domains',
    'groups',
    'images',
    'integrations',
    'staff',
    'studio',
    'users',
    'videos',
    'workflows'
  ].forEach((page) => {
    const storageKey = page === 'staff' ? `${page}:settings` : `${domain}:${page}:settings`;
    const settings = LocalStorage.get(storageKey);

    if (!settings) {
      LocalStorage.create(storageKey, {});
    }

    if (page === 'activity') {
      activitySettingsStore = writable(LocalStorage.get(storageKey));
      activitySettingsStore.subscribe((store) => LocalStorage.update(storageKey, store));
    }

    if (page === 'app') {
      appSettingsStore = writable(LocalStorage.get(storageKey));
      appSettingsStore.subscribe((store) => LocalStorage.update(storageKey, store));
    }

    if (page === 'audit') {
      auditSettingsStore = writable(LocalStorage.get(storageKey));
      auditSettingsStore.subscribe((store) => LocalStorage.update(storageKey, store));
    }

    if (page === 'bizcards-studio') {
      bizStudioSettingsStore = writable(LocalStorage.get(storageKey));
      bizStudioSettingsStore.subscribe((store) => LocalStorage.update(storageKey, store));
    }

    if (page === 'campaigns') {
      campaignsSettingsStore = writable(LocalStorage.get(storageKey));
      campaignsSettingsStore.subscribe((store) => LocalStorage.update(storageKey, store));
    }

    if (page === 'documents') {
      documentsSettingsStore = writable(LocalStorage.get(storageKey));
      documentsSettingsStore.subscribe((store) => LocalStorage.update(storageKey, store));
    }

    if (page === 'domains') {
      domainsSettingsStore = writable(LocalStorage.get(storageKey));
      domainsSettingsStore.subscribe((store) => LocalStorage.update(storageKey, store));
    }

    if (page === 'domain-settings') {
      domainSettingsStore = writable(LocalStorage.get(storageKey));
      domainSettingsStore.subscribe((store) => LocalStorage.update(storageKey, store));
    }

    if (page === 'groups') {
      groupsSettingsStore = writable(LocalStorage.get(storageKey));
      groupsSettingsStore.subscribe((store) => LocalStorage.update(storageKey, store));
    }

    if (page === 'images') {
      imagesSettingsStore = writable(LocalStorage.get(storageKey));
      imagesSettingsStore.subscribe((store) => LocalStorage.update(storageKey, store));
    }

    if (page === 'integrations') {
      integrationsSettingsStore = writable(LocalStorage.get(storageKey));
      integrationsSettingsStore.subscribe((store) => LocalStorage.update(storageKey, store));
    }

    if (page === 'staff') {
      staffSettingsStore = writable(LocalStorage.get(storageKey));
      staffSettingsStore.subscribe((store) => LocalStorage.update(storageKey, store));
    }

    if (page === 'studio') {
      studioSettingsStore = writable(LocalStorage.get(storageKey));
      studioSettingsStore.subscribe((store) => LocalStorage.update(storageKey, store));
    }

    if (page === 'users') {
      usersSettingsStore = writable(LocalStorage.get(storageKey));
      usersSettingsStore.subscribe((store) => LocalStorage.update(storageKey, store));
    }

    if (page === 'videos') {
      videosSettingsStore = writable(LocalStorage.get(storageKey));
      videosSettingsStore.subscribe((store) => LocalStorage.update(storageKey, store));
    }

    if (page === 'workflows') {
      workflowsSettingsStore = writable(LocalStorage.get(storageKey));
      workflowsSettingsStore.subscribe((store) => LocalStorage.update(storageKey, store));
    }
  });
};

updateStores(initialUserStore);

userStore.subscribe(updateStores);
